import { render, staticRenderFns } from "./AjoutEmbryon.vue?vue&type=template&id=0e87fa86&"
import script from "./AjoutEmbryon.vue?vue&type=script&lang=js&"
export * from "./AjoutEmbryon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports